var u = "\\ud800-\\udfff", t = "\\u0300-\\u036f", i = "\\ufe20-\\ufe2f", b = "\\u20d0-\\u20ff", g = t + i + b, l = "\\ufe0e\\ufe0f", m = "[" + u + "]", r = "[" + g + "]", f = "\\ud83c[\\udffb-\\udfff]", R = "(?:" + r + "|" + f + ")", a = "[^" + u + "]", e = "(?:\\ud83c[\\udde6-\\uddff]){2}", o = "[\\ud800-\\udbff][\\udc00-\\udfff]", c = "\\u200d", s = R + "?", d = "[" + l + "]?", p = "(?:" + c + "(?:" + [a, e, o].join("|") + ")" + d + s + ")*", C = d + s + p, v = "(?:" + [a + r + "?", r, e, o, m].join("|") + ")", A = RegExp(f + "(?=" + f + ")|" + v + C, "g");
function M(n) {
  return n.match(A) || [];
}
export {
  M as default
};
